import type { ReactNode } from "react";

/**
 * The full-viewport, centered layout region every public page (this site's, and a tenant's) is
 * built inside — structure lives here once instead of each page hand-rolling its own wrapper
 * `<div>` (`.github/instructions/marketing-site.instructions.md`).
 */
export function Page({ children }: { children: ReactNode }) {
  return <main className="site-page">{children}</main>;
}
